module.exports = __webpack_public_path__ + "img/instagram.9dbfb8c2.svg";